import React from 'react';

import { Box, rem } from '@vimeo/bokeh';
import { useIsMobile } from '@vimeo/core/hooks/use-is-mobile';

interface IframeProps {
  src: string;
  title: string;
  onLoad?: VoidFunction;
}

const Iframe = ({ src, title, onLoad }: IframeProps) => {
  const isMobile = useIsMobile();
  return (
    <Box
      position="relative"
      overflow="hidden"
      maxHeight={isMobile ? `calc(100vh - ${rem(172)})` : rem(687)}
      maxWidth={isMobile ? '100%' : rem(600)}
      minWidth={rem(375)}
      height={rem(687)}
      borderRadius={isMobile ? `0 0 ${rem(20)} ${rem(20)}` : `0 ${rem(20)} ${rem(20)} 0`}
      sx={{
        '& > iframe': {
          position: 'absolute',
          left: '0',
          top: '0',
          height: '100%',
          width: '100%',
          border: '0',
          overflow: 'hidden',
        },
      }}
    >
      <iframe id="marktoFromIframe" src={src} title={title} onLoad={onLoad} />
    </Box>
  );
};

export default Iframe;
